import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=459de0b0&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459de0b0",
  null
  
)

export default component.exports